export default ($axios) => ({
    $axios,

    async fetch() {
        return await $axios.get('/pdf')
    },

    async generate(form) {
        return await $axios.post('/pdf', form)
    },

    async sendEmail({
        id,
        email,
    }) {
        return await $axios.post(`/pdf/${id}/send-email`, {
            email,
        })
    },

    async remove(pdf_id) {
        return await $axios.delete(`/pdf/${pdf_id}`)
    },
})
